/**
 * Our custom edits for the AvisOptions plugin.
 * for better UX.
 *
 * @see apo-product-options-v3.js
 * possible events to listen to:
 * - productoptions.appLoad
 * - productoptions.fieldLoad
 * - productoptions.fieldChange
 * - productoptions.productBundleAdd
 * - productoptions.productBundleRemove
 * - productoptions.fieldShow
 * - productoptions.fieldHide
 * - productoptions.validationFail
 * - productoptions.validationSuccess
 * - productoptions.productBundleCartSubmit
 * - productoptions.beforeVariantPost
 * - productoptions.beforeVariantsPost
 *
 */

(function () {

  console.log('AvisOptions edits loaded');
  var selectors = {
    comboSelectChecked: '.option-avis-checked',
    comboSelectLabel: 'label.avp-productoptioncheckwrapper',
    comboPlaceholder: '.combo_input-container',
  };

  // Normalize all emoji variants to ♡ on all text fields, regardless of theme config
  document.addEventListener('productoptions.fieldLoad', function (event) {
    if (event.detail.fieldConfig.type !== 'text') return;

    var element = event.detail.element.get(0);
    element.addEventListener('input', function (event) {
      if (event.detail && event.detail.programmatic) return;

      var value = event.target.value;
      var normalized = value.replace(/\p{Extended_Pictographic}(?:[\uFE0E\uFE0F]|[\u{1F3FB}-\u{1F3FF}]|\u20E3)?(?:\u200D\p{Extended_Pictographic}(?:[\uFE0E\uFE0F]|[\u{1F3FB}-\u{1F3FF}]|\u20E3)?)*\uFE0F?/gu, '♡');

      if (value !== normalized) {
        event.target.value = normalized;
        event.target.dispatchEvent(new CustomEvent('input', { bubbles: true, detail: { programmatic: true } }));
      }
    });
  });

  // Validation text field and allow lowercase and spacial signs only !@#$%^&*()_+-=~`{}[]|\\:;"'<>,.?/
  if (window.themeConfig && window.themeConfig.general && window.themeConfig.general.validateCustomizeFields) {
    if (window.themeConfig.product && window.themeConfig.product.shouldValidateCustomize) {
      function setAlertText(element, text) {
        if (!element) return;

        // Search the whole option so a previously created alert is always found, no matter
        // which nested element the caller passed in.
        var container = element.closest('.avp-option') || element;
        var textFieldWrapper = container.querySelector('.apo-text-field');
        var host = (textFieldWrapper && textFieldWrapper.parentElement) || container;

        var existingAlerts = container.querySelectorAll('.customize-validation-alert');
        let errorElement = existingAlerts[0];
        for (var i = 1; i < existingAlerts.length; i++) existingAlerts[i].remove();

        if (!errorElement) {
          errorElement = document.createElement('div');
          errorElement.className = 'customize-validation-alert';
          errorElement.style.color = '#ad0000';
          errorElement.style.fontSize = '0.7em';
          errorElement.style.marginBottom = '5px';
          errorElement.style.display = 'none';
        }

        // Keep the alert last after the text field, but above the AI preview button which
        // must stay the final element of the option.
        var buttonWrap = host.querySelector(':scope > .lisa-ai-modal__button-wrap');
        if (buttonWrap) {
          if (errorElement.nextElementSibling !== buttonWrap) host.insertBefore(errorElement, buttonWrap);
        } else if (host.lastElementChild !== errorElement) {
          host.appendChild(errorElement);
        }

        // Set the alert text
        errorElement.textContent = text;

        // If text is empty, hide the error element
        if (text === '') {
          errorElement.style.display = 'none';
        } else {
          errorElement.style.display = 'block';
        }
      }

      // Use a flag to prevent multiple alerts
      var customizeValidationAlertShown = false;
      document.addEventListener('productoptions.fieldLoad', function (event) {
        var inputType = event.detail.fieldConfig.type;
        var $element = event.detail.element;
        var element = $element.get(0);

        if (inputType === 'text') {
          element.addEventListener('input', function (event) {
            if (event.detail && event.detail.programmatic) return;

            var value = event.target.value;

            // Change all to lowercase
            var validValue = value.toLowerCase();

            validValue = validValue.replace(/[^a-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~ ♡]/gu, '');

            // If the value is different, update it
            if (value !== validValue) {
              event.target.value = validValue;

              event.target.dispatchEvent(
                new CustomEvent('input', {
                  bubbles: true,
                  detail: { programmatic: true },
                }),
              );

              event.preventDefault();
              if (!customizeValidationAlertShown) {
                customizeValidationAlertShown = true;
                setAlertText(event.target.parentElement.parentElement, window.productStrings.customizeValidationText);
              }
            } else {
              // Reset the flag when input is valid again
              customizeValidationAlertShown = false;
              setAlertText(event.target.parentElement.parentElement, '');
            }
          });
        }
      });
    }
  }

  // Heart button for text fields
  if (window.themeConfig && window.themeConfig.general && window.themeConfig.general.customizeHeartButtonText) {
    document.addEventListener('productoptions.fieldLoad', function (event) {
      var inputType = event.detail.fieldConfig.type;
      if (inputType !== 'text') return;

      var $element = event.detail.element;
      var element = $element.get(0);
      var textField = element.querySelector('.apo-text-field');
      if (!textField) return;

      var heartBtn = document.createElement('button');
      heartBtn.type = 'button';
      heartBtn.className = 'customize-heart-button';
      heartBtn.textContent = window.themeConfig.general.customizeHeartButtonText;

      heartBtn.addEventListener('click', function () {
        var input = textField.querySelector('input[type="text"], textarea');
        if (!input) return;

        var start = input.selectionStart;
        var end = input.selectionEnd;
        var value = input.value;
        var heartChar = '♡';

        input.value = value.slice(0, start) + heartChar + value.slice(end);
        input.selectionStart = input.selectionEnd = start + heartChar.length;

        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });

      textField.insertAdjacentElement('afterend', heartBtn);
    });
  }

  // Convert inches to cm for UK/CA market
  if (
    window.themeConfig &&
    window.themeConfig.localization &&
    window.themeConfig.localization.market &&
    (window.themeConfig.localization.market.handle === 'united-kingdom' ||
      window.themeConfig.localization.market.handle === 'canada')
  ) {
    document.addEventListener('productoptions.fieldLoad', function (event) {
      var inputType = event.detail.fieldConfig.type;
      var cartLabel = event.detail.fieldConfig.label_cart;
      var name = event.detail.name;
      var $element = event.detail.element;
      var element = $element.get(0);

      // Check if name or cart label contains 'chain length'
      if (
        inputType === 'select' ||
        (name && name.toLowerCase().includes('chain length')) ||
        (cartLabel && cartLabel.toLowerCase().includes('chain length'))
      ) {
        // Change the option values and text to cm
        var options = element.querySelectorAll('option');
        options.forEach(function (option) {
          var inchesValue = parseFloat(option.value);
          if (!isNaN(inchesValue)) {
            // Convert inches to cm (1 inch = 2.54 cm)
            var cmValue = (inchesValue * 2.54).toFixed(1);

            // keep the sentence structure and replace the inch value with cm value
            // for exmaple:
            // 16" Sterling silver link chain (+$0.00)
            // should be 40.6 cm Sterling silver link chain (+$0.00)
            var text = option.textContent;
            var value = option.value;
            var inchRegex = /(\d+(\.\d+)?)\s*"/;
            if (inchRegex.test(text)) {
              text = text.replace(inchRegex, inchesValue + '" / ' + cmValue + 'cm');
            }

            if (inchRegex.test(value)) {
              value = value.replace(inchRegex, inchesValue + '" / ' + cmValue + 'cm');
            }

            option.value = value;
            option.textContent = text;
          }
        });
      }
    });
  }

  function fixCamelCaseLables(avisFields) {
    var fieldSet = avisFields[0];
    if (!fieldSet) return;

    fieldSet.forEach(function (field) {
      var key = field.key;
      if (!key) return;

      var element = document.querySelector('.avp-option[key="' + key + '"] .avp-option-title .apo-title');

      if (element) {
        // Convert the text to camel case and preserve spaces
        var text = element.textContent.trim();
        var camelCaseText = text
          .split(' ')
          .map(function (word, index) {
            // Capitalize the first letter of each word except the first one
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
          .join(' ');

        // Set the new text
        element.textContent = camelCaseText;
      }
    });
  }

  document.addEventListener('productoptions.appLoad', function (event) {
    var fields = event.detail.fields;

    fixCamelCaseLables(fields);
  });

  /**
   * Due to Avis not closing the combo select on selection
   * we need to close it manually.
   */
  document.addEventListener('productoptions.fieldLoad', function (event) {
    var inputType = event.detail.fieldConfig.type;
    var $element = event.detail.element;
    var element = $element.get(0);

    // Handle the combo select options
    if (inputType === 'combo_select' || inputType === 'combo_image') {
      var checkboxLabels = element.querySelectorAll(selectors.comboSelectLabel);
      checkboxLabels.forEach(function (label) {
        label.addEventListener('click', function (event) {
          closeComboOnSelection(event, element);
        });
      });
    }
  });

  function closeComboOnSelection(event, parentElement, type) {
    var label = event.target.tagName === 'LABEL' ? event.target : event.target.closest('label');

    var checked = label.classList.contains(selectors.comboSelectChecked.replace('.', ''));

    // if the item is not checked. deselect current item, select the new one and close the combo.
    if (!checked) {
      var currentChecked = parentElement.querySelector(selectors.comboSelectChecked);
      if (currentChecked) {
        setTimeout(function () {
          currentChecked.querySelector('input[type="checkbox"]').click();
        }, 0);

        setTimeout(function () {
          label.querySelector('input[type="checkbox"]').click();
          // close the combo by clicking on the parent
          parentElement.click();
        }, 300);
      } else {
        // close the combo by clicking on the parent
        parentElement.click();
      }
    }
  }

  /**
   * Avis is taking over the native product-form submit logic.
   * we want to fire our event when the add to cart is done.
   */
  document.addEventListener('productoptions.beforeVariantsPost', function (event) {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-form',
      action: 'add',
      placement: 'buy-buttons',
    });
  });
})();
